'use es6';

import { Map as ImmutableMap } from 'immutable';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { isSupportedCrmObject } from 'reporting-data/crmObjects/utils';

/**
 * returns true if the config is ready to be rendered using `reporting-visualizations`
 *
 * @param {*} report report to check if enabled
 */
export const isEnabledForViz = report => {
  try {
    const shouldUseVizExclusively = report.get('v2') ||
    // Custom object reports should always try to render with V2
    isSupportedCrmObject(report.getIn(['config', 'dataType']));
    const chartType = report.get('chartType');
    const displayParams = report.get('displayParams') || ImmutableMap();
    const isUnsupportedPivotTable = chartType === TABLE && displayParams.get('pivot');
    return shouldUseVizExclusively || !isUnsupportedPivotTable;
  } catch (exception) {
    return true;
  }
};